import smallCube from './svg/small_cube.svg';
import largeCube from './svg/large_cube.svg';

const SVG_ICONS_NOT_FOUND = {
  SMALL_CUB: smallCube,
  LARGE_CUB: largeCube,
};

export default SVG_ICONS_NOT_FOUND;
